import styled from 'styled-components';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import colors from '../../design-system/colors';
import fonts from '../../design-system/fonts';

export const PopoverContainer = styled(motion.div)`
  position: fixed;
  top: 75px;
  left: 0;
  right: 0;
  width: 100vw;
  z-index: 1001;
  pointer-events: auto;
  display: flex;
  justify-content: center;
  padding: 0 40px;
  box-sizing: border-box;

  @media (max-width: 1024px) {
    padding: 0 30px;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export const PopoverContent = styled.div`
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
  padding: 40px;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  position: relative;
  border: 1px solid rgba(0, 0, 0, 0.05);

  @media (max-width: 1024px) {
    padding: 32px;
  }

  @media (max-width: 768px) {
    padding: 24px;
  }
`;

export const PopoverArrow = styled.div`
  position: absolute;
  top: -8px;
  left: 0;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 8px solid #ffffff;
`;

export const CategoryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 32px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(1, 1fr);
    gap: 16px;
  }
`;

export const CategoryItem = styled(motion(Link))`
  display: flex;
  align-items: flex-start;
  gap: 20px;
  padding: 16px;
  text-decoration: none;
  color: inherit;
  transition: all 0.3s cubic-bezier(0.25, 0.1, 0.25, 1);
  cursor: pointer;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06), 0 1px 3px rgba(0, 0, 0, 0.04);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: linear-gradient(
      90deg,
      ${colors.sapphire},
      ${colors.frenchBlue}
    );
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &:hover {
    background: #ffffff;
    border-color: rgba(28, 80, 196, 0.2);
    transform: translateY(-6px);
    box-shadow: 0 8px 24px rgba(28, 80, 196, 0.15),
      0 4px 12px rgba(0, 0, 0, 0.1), 0 0 0 1px rgba(28, 80, 196, 0.1);

    &::before {
      opacity: 1;
    }
  }

  &:active {
    transform: translateY(-3px);
    box-shadow: 0 4px 16px rgba(28, 80, 196, 0.12),
      0 2px 8px rgba(0, 0, 0, 0.08);
  }

  @media (max-width: 1024px) {
    padding: 14px;
    gap: 16px;
    border-radius: 10px;
  }
`;

export const CategoryImage = styled.img`
  width: 80px;
  height: 80px;
  object-fit: fill;
  border-radius: 8px;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  transition: all 0.4s cubic-bezier(0.25, 0.1, 0.25, 1);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);

  ${CategoryItem}:hover & {
    transform: scale(1.08);
    border-color: rgba(28, 80, 196, 0.3);
    box-shadow: 0 4px 12px rgba(28, 80, 196, 0.2);
  }

  @media (max-width: 1024px) {
    width: 70px;
    height: 70px;
    border-radius: 6px;
  }
`;

export const CategoryName = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: ${colors.deepCharcoal};
  text-align: left;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  font-family: ${fonts.body};
  flex: 1;
  line-height: 1.3;
  transition: all 0.3s ease;
  padding-top: 4px;

  ${CategoryItem}:hover & {
    color: ${colors.sapphire};
  }

  @media (max-width: 1024px) {
    font-size: 13px;
  }
`;
